import axios from "./axios";

export default {
  async getSellerZones() {
    const options = {
      method: "GET",
      url: "seller-zones",
      headers: { "content-type": "application/json" },
    };
    const sellerZonesResponse = await axios(options);
    return sellerZonesResponse.data.data;
  },
  async addSellerZone(zone) {
    const options = {
      method: "POST",
      url: "seller-zones",
      headers: { "content-type": "application/json" },
      data: zone,
    };
    const sellerZonesResponse = await axios(options);
    return sellerZonesResponse.data.data;
  },
  async deleteSellerZoneBy(zoneId) {
    const options = {
      method: "DELETE",
      url: `seller-zones/${zoneId}`,
      headers: { "content-type": "application/json" },
    };
    const sellerZonesResponse = await axios(options);
    return sellerZonesResponse.data;
  },
  async relateSellerWithZone(sellerId, zoneId) {
    const options = {
      method: "PUT",
      url: `seller-zones/${zoneId}/seller/${sellerId}`,
      headers: { "content-type": "application/json" },
    };
    const sellerZonesResponse = await axios(options);
    return sellerZonesResponse.data;
  },
};
